import {
  FooterContainer,
  StepTitle,
  WizardContentWrapper,
  FooterSkipButton,
  StyledStepTitleWrapper,
} from "@/components/onboarding/components/welcome-wizard/welcome-wizard.styles";
import type { StepProps } from "@/components/onboarding/components/welcome-wizard/welcome-wizard.types";
import { MDSIconButton, MDSText, MDSTextVariant, MDSTextWeight, MDSIconKind, MDSLink } from "@/mds";
import { StepGroups } from "@/components/onboarding/components/welcome-wizard/welcome-wizard.config";
import { StepContentWithTabs } from "@/components/onboarding/components/welcome-wizard/tabs";
import styled from "@emotion/styled";

// New one-click import step for web (feature flag enabled)
export const AppleNotesOneClickStepWeb: React.FC<StepProps> = ({
  context,
  handleTabSelect,
  onSkip,
  onClose,
}) => {
  return (
    <WizardContentWrapper>
      <StyledStepTitleWrapper>
        <StepTitle>Import Notes</StepTitle>
        {context.wizardType === "import" && (
          <MDSIconButton iconKind={MDSIconKind.Exit} onClick={onClose} />
        )}
      </StyledStepTitleWrapper>
      <StepContentWithTabs
        selectedAppId={context?.selectedAppId || null}
        onAppSelect={handleTabSelect}
        tabConfig={StepGroups["IMPORT"].tabConfig}
      >
        <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
          To import Apple Notes easily install{" "}
          <StyledLink href="https://get.mem.ai/download" target="_blank" rel="noreferrer">
            Mem desktop app
          </StyledLink>
        </MDSText>
      </StepContentWithTabs>
      {onSkip && (
        <FooterContainer align="space-between">
          <FooterSkipButton onClick={onSkip} isDisabled={!onSkip}>
            Skip for now
          </FooterSkipButton>
        </FooterContainer>
      )}
    </WizardContentWrapper>
  );
};

const StyledLink = styled(MDSLink)`
  color: ${({ theme }) => theme.colors.text.primary};

  &:hover:not([data-disabled]) {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;
